import { render, staticRenderFns } from "./BoardAds.vue?vue&type=template&id=b0af4c70"
import script from "./BoardAds.vue?vue&type=script&lang=js"
export * from "./BoardAds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports